import {ProductListPage} from "@app/core/product/domain/dtos/product-list-page";
import {ProductMapper} from "@app/core/product/infrastructure/mappers/product.mapper";

export class ProductListPageMapper {
    static deserialize(param: any): ProductListPage {
        return {
            totalPages: param.totalPages,
            totalProducts: param.totalResults,
            products: param.results.product.map(ProductMapper.deserialize),
            name: param.results.name,
            image: param.results.imageBigUrl,
            breadcrumbs: param.results.breadcrumb.map((breadcrumb: any) => {
                return {
                    name: breadcrumb.name,
                    code: breadcrumb.code,
                }
            }),
        }

    }
}
